// src/components/modalForm/ModalActions.js
import React, { Children, isValidElement } from 'react';
import { FiCheck, FiCopy, FiPlus, FiPrinter, FiSave, FiTrash2, FiX } from 'react-icons/fi';

const icons = { save: FiSave, delete: FiTrash2, new: FiPlus, close: FiX, duplicate: FiCopy, confirm: FiCheck, apply: FiCheck, add: FiPlus, print: FiPrinter };
const variants = { save: 'primary', delete: 'outline-danger', new: 'outline-secondary', close: 'outline-secondary', duplicate: 'outline-secondary', confirm: 'primary', apply: 'primary', add: 'primary', print: 'outline-secondary' };

export const orderModalActions = (children) => Children.toArray(children).sort((a, b) => {
  const order = (child) => isValidElement(child) && child.type === ModalActionButton
    ? ({ new: 1, delete: 2, save: 4, confirm: 4, apply: 4, add: 4 }[child.props.action] || 3)
    : 3;
  return order(a) - order(b);
});

export const ModalActionButton = ({ action, children, className = '', ...props }) => {
  const Icon = icons[action];
  const extraClasses = className.split(/\s+/).filter((name) => name && name !== 'btn' && !/^btn-(primary|danger|secondary|success|warning|info|light|dark|link|outline-[a-z]+)$/.test(name));
  return (
    <button type="button" {...props} className={`btn btn-${variants[action] || 'outline-secondary'} modal-action modal-action-${action} ${extraClasses.join(' ')}`.trim()}>
      {Icon && <Icon aria-hidden="true" />}
      <span>{children}</span>
    </button>
  );
};

const ModalActions = ({ children, className = '', ...props }) => <div {...props} className={`modal-actions ${className}`.trim()}>{orderModalActions(children)}</div>;
export default ModalActions;
